/** Import-free so vitest can load it: `time.ts` pulls in `./api` and MSAL. */
import type { ApiLogLine } from './time'

const LINE_HOURS = ['hours', 'overtime_hours', 'nighttime_hours', 'over_night_hours', 'transit_hours'] as const

/** The API serves line hours as Decimal text ("8.00"); parse them once so `+` adds and "0" is falsy. */
export function withNumericHours<T extends { lines: ApiLogLine[] }>(day: T): T {
  return {
    ...day,
    lines: day.lines.map((line) => {
      const parsed = { ...line }
      for (const f of LINE_HOURS) parsed[f] = Number(line[f])
      return parsed
    }),
  }
}
